/** Marks the artist index a stale settlement URL fell back to, so the index can say why. */
export const UNAVAILABLE_SETTLEMENT_QUERY = { settlement: 'unavailable' } as const;
